module.exports = __webpack_public_path__ + "images/add-product-group-c56989dd.svg";